import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const year = new Date().getFullYear();

export function Footer() {
  return (
    <>
      <div className="gg-mfooter" data-testid="mobile-footer">
        <Link to="/chi-siamo">Chi siamo</Link>|<Link to="/contatti">Contatti</Link>|<Link to="/termini">Termini</Link>|<Link to="/privacy">Privacy</Link>
        <div style={{ marginTop: 8 }}>Giochi.Gratis &copy; {year}</div>
      </div>
      <div id="footer" className="fix" style={{ zIndex: 999999999 }} data-testid="site-footer">
        <div className="foot-inner">
          <div className="link-b fn-left">
            <Link to="/contatti" data-testid="footer-contact">Contatti</Link> |{" "}
            <Link to="/chi-siamo" data-testid="footer-about">Chi siamo</Link> |{" "}
            <Link to="/categorie">Categorie</Link>
          </div>
          <div className="link-b fn-right">
            <Link to="/termini" data-testid="footer-terms">Termini</Link> |{" "}
            <Link to="/privacy" data-testid="footer-privacy">Privacy e Cookie</Link> |{" "}
            <span>Giochi.Gratis &copy; {year}</span>
          </div>
          <div className="link-b2">
            <Link to="/casuale" data-testid="footer-random">Gioco casuale</Link>
          </div>
        </div>
      </div>
    </>
  );
}

export function BackTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const f = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", f, { passive: true });
    return () => window.removeEventListener("scroll", f);
  }, []);
  if (!show) return null;
  return (
    <div
      id="BackTop"
      role="button"
      aria-label="Torna su"
      data-testid="back-to-top"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      style={{ background: "url(/kizi/image/backtotop.png) no-repeat center" }}
    />
  );
}
